// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__D3U_d4lY","tick":"tick__OwTUFTuk"};